<!-- ResourceTemplate-->
<ng-template #resourceTemplate let-values="values" let-p="p">
	<span class="fs-5 fw-bold text-gray-900" translate>{{ values.label }}</span>
</ng-template>

<!-- PermissionsTemplate-->
<ng-template #permissionsTemplate let-values="values" let-p="p">
	<div class="d-flex justify-content-start gap-3">
		<!-- Create -->
		<button
			class="btn rounded-pill py-3 px-4 w-100 fs-6 fw-semibold d-inline-flex align-items-center justify-content-center"
			[class.btn-primary]="values.create"
			[class.btn-light]="!values.create"
			(click)="values.create = !values.create"
		>
			<app-keenicon name="plus-circle" class="fs-4 me-2"></app-keenicon>
			<span translate>create_role_drawer_label_create</span>
		</button>

		<!-- Read -->
		<button
			class="btn rounded-pill py-3 px-4 w-100 fs-6 fw-semibold d-inline-flex align-items-center justify-content-center"
			[class.btn-primary]="values.read"
			[class.btn-light]="!values.read"
			(click)="values.read = !values.read"
		>
			<app-keenicon name="eye" class="fs-5 me-2"></app-keenicon>
			<span translate>create_role_drawer_label_read</span>
		</button>

		<!-- Update -->
		<button
			class="btn rounded-pill py-3 px-4 w-100 fs-6 fw-semibold d-inline-flex align-items-center justify-content-center"
			[class.btn-primary]="values.update"
			[class.btn-light]="!values.update"
			(click)="values.update = !values.update"
		>
			<app-keenicon name="pencil" class="fs-5 me-2"></app-keenicon>
			<span translate>create_role_drawer_label_update</span>
		</button>

		<!-- Delete -->
		<button
			class="btn rounded-pill py-3 px-4 w-100 fs-6 fw-semibold d-inline-flex align-items-center justify-content-center"
			[class.btn-primary]="values.delete"
			[class.btn-light]="!values.delete"
			(click)="values.delete = !values.delete"
		>
			<app-keenicon name="trash" class="fs-5 me-2"></app-keenicon>
			<span translate>create_role_drawer_label_delete</span>
		</button>
	</div>
</ng-template>

<div
	id="kt_create_company_role"
	class="bg-body"
	data-kt-drawer="true"
	data-kt-drawer-name="create_company_role"
	data-kt-drawer-activate="true"
	data-kt-drawer-overlay="true"
	data-kt-drawer-width="{default:'100%', 'lg': '900px'}"
	data-kt-drawer-direction="end"
	data-kt-drawer-toggle="#kt_create_company_role_toggle"
	data-kt-drawer-close="#kt_create_company_role_close"
>
	<!-- Drawer content -->

	<div class="card shadow-none rounded-0 w-100">
		<div class="card-header" id="kt_create_company_role_header">
			<h3 class="card-title fw-bolder text-gray-900" translate>create_role_drawer_title</h3>
			<span class="text-muted fs-7 fw-semibold" translate>create_role_drawer_description</span>
		</div>
		<div class="card-body position-relative" id="kt_create_company_role_body">
			<div
				id="kt_create_company_role_scroll"
				class="position-relative scroll-y me-n5 pe-5"
				data-kt-scroll="true"
				data-kt-scroll-height="auto"
				data-kt-scroll-wrappers="#kt_create_company_role_body"
				data-kt-scroll-dependencies="#kt_create_company_role_header, #kt_create_company_role_footer"
				data-kt-scroll-offset="0px"
			>
				<div>
					<!-- Role form fields will go here -->
					<div class="fv-row mb-7">
						<label class="required fw-semibold fs-6 mb-2" translate>create_role_drawer_label_name</label>
						<input
							type="text"
							class="form-control form-control-solid mb-3 mb-lg-0"
							[(ngModel)]="roleName"
							(input)="validateRoleName()"
							placeholder="{{ 'create_role_drawer_label_name_placeholder' | translate }}"
						/>
						@if (roleNameError) {
							<div class="fv-plugins-message-container invalid-feedback">
								{{ 'create_store_form_label_name_error' | translate }}
							</div>
						}
					</div>

					<div class="fv-row mb-7">
						<label class="required fw-semibold fs-6 mb-2" translate>create_role_drawer_label_active</label>
						<div class="form-check form-switch form-check-custom form-check-solid">
							<input class="form-check-input" type="checkbox" [(ngModel)]="roleActive" name="create_role_drawer_label_active" id="create_role_drawer_label_active" />
						</div>
					</div>

					<!-- Table -->
					@if (permissions$ | async) {
						<div class="row g-5 g-xl-10 mb-5 mb-xl-10">
							<div class="table-responsive">
								<app-table
									[fields]="tableFields"
									(catchItemsToSort)="catchItemsToSort($event)"
									[values]="permissions$ | async"
									[showCheckboxDelete]="false"
									(catchItemsToDelete)="catchItemsToDelete($event)"
								></app-table>
							</div>
						</div>
					}
				</div>
			</div>
		</div>
		<div class="card-footer py-5 d-flex justify-content-between align-items-center" id="kt_create_company_role_footer">
			<button id="kt_create_company_role_close" type="button" class="hover-elevate-up btn btn-light d-flex justify-content-between round py-4">
				<app-keenicon name="to-left" class="fs-3 text-muted me-3"></app-keenicon>
				<span class="text-muted font-size-sm" translate>drawer_back</span>
			</button>
			<button type="button" class="hover-elevate-up btn btn-primary d-flex justify-content-between round py-4" (click)="saveCompanyRole()">
				<span class="text-white font-size-sm me-2" [translate]="activeRole ? 'drawer_update' : 'drawer_create'"></span>
				<app-keenicon name="rocket" class="fs-3 text-white"></app-keenicon>
			</button>
		</div>
	</div>
</div>
